import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './AnalyticsToggler.module.scss';

export function AnalyticsToggler({ selected, onChange, options }) {
  return (
    <div className={styles.analyticsTogglerWrapper}>
      {options.map((option) => (
        <button
          key={option.value}
          className={cn(styles.option, option.value === selected ? styles.selected : '')}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

AnalyticsToggler.propTypes = {
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
